var MDB = window.MDB || {};
MDB.Account = MDB.Account || {};
MDB.Account.Tfa = MDB.Account.Tfa || {};

(function($) {
    $.extend(MDB.Account.Tfa, {
        renderQrCodes: renderQrCodes,
        
        initEditorControls: initEditorControls
    });
    
    function renderQrCodes(selector){
        selector = selector || '.qr-code';
        $(selector).each(function(i){
            var me = this
                , $me = $(this);
            
            new QRCode(me, {
                text: $me.data('text'),
                width: 200,
                height: 200,
                colorDark : "#000000",
                colorLight : "#ffffff",
                correctLevel : QRCode.CorrectLevel.L
            });
            
            $me.attr('title', null);
        });
    }
    
    function initEditorControls(selector){
        var container = $(selector || '#2f-auth-container');

        container.on('click', '#send-test-request', function (e) {
            e.preventDefault();

            var params = $.param({ userId: $('#Id').val() });

            MDB.callApi({
                url: $(this).data('url') + '?' + params,
                type: 'POST',
                success: function () {
                    MDB.alert('Notification Send')
                },
                error: function (e,x,d) {
                    var message = e.statusText;

                    if (e.responseJSON) {
                        message = _.values(e.responseJSON).join('/n');
                    }

                    MDB.alert(message || 'Error');
                }
            });
        });

        container.on('click', '#2fa-toggle, #new-secret', function (e) {
            e.preventDefault();

            var self = $(this);
            var btnText = self.text().trim();
            $.ajax({
                url: self.data("url"),
                type: "POST",
                data: { isDisabled: btnText === MDB.loadResourceString('Account_Edit_2Factor_Disable_Button') },
                success: function (html) {
                    container.empty();
                    container.append(html);
                }
            });
        });   
    }
})(jQuery);